import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToImageAiConfig } from '@/data/landingConfig/landingImageToImageAiConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToImageAi } from './schemaObject';

interface Props {}
const ImageToImageAi: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToImageAi} />
			<LandingTemplate
				data={landingImageToImageAiConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default ImageToImageAi;
